import { render } from "./Existencias.vue?vue&type=template&id=526fa892&scoped=true"
import script from "./Existencias.vue?vue&type=script&lang=js"
export * from "./Existencias.vue?vue&type=script&lang=js"

import "./Existencias.vue?vue&type=style&index=0&id=526fa892&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526fa892"]])

export default __exports__